// imports
import React from 'react';
import { cpp as arrowUpIcon } from '../Icons/cpp';

import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Container from 'common/src/components/UI/Container';

import data from './data';
import SectionWrapper, { CounterItem, CounterWrapper } from './metrics.style';

// globals
const { counterItems } = data;

// exports - react class
export default class Metrics extends React.Component {
  constructor(props) {
    super(props);
  }

  // react lifecycle
  render() {
    return (
      <SectionWrapper id='metrics_integration'>
        <Container>
          <CounterWrapper>
            {this.renderMetrics()}
          </CounterWrapper>
        </Container>
      </SectionWrapper>
    );
  }

  // render helpers
  renderMetrics() {
    return counterItems.map((item, idx) => {
      const { title, amount, className } = item;
      return (
        <CounterItem className={className || ''} key={`counter_key${idx}`}>
          <Heading as='h3' content={amount} />
          <Text content={title} />
        </CounterItem>
      );
    });
  }
}